import React from "react";
import './css/DeliveryInfo.css';


const DeliveryInfo = () => {
  return (
    <div className="delivery-info">
      <div className="delivery-description">
        <h1>מידע על משלוחים</h1>
        <p>
          לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סוספנדיס לורם איפסום
          דולור סיט אמט נונסטי סוליקו קוואזי. קוואזי פרוייקט איי יו עיצמות קרטח טסניקט.
          בראיט לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סוליקו בלובסטיק
          עיצמות קרטח טסניקט סוספנדיס. לורם איפסום דולור סיט אמט קרטח. קונסקטורר
          אדיפיסינג בלובסטיק פרוייקט איי יו קוואזי. סוספנדיס סוליקו לורם איפסום.
          לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סוספנדיס לורם איפסום
          דולור סיט אמט נונסטי סוליקו קוואזי. קוואזי פרוייקט איי יו עיצמות קרטח טסניקט.
          בראיט לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סוליקו בלובסטיק
          עיצמות קרטח טסניקט סוספנדיס. לורם איפסום דולור סיט אמט קרטח. קונסקטורר
          אדיפיסינג בלובסטיק פרוייקט איי יו קוואזי. סוספנדיס סוליקו לורם איפסום.
          לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סוספנדיס לורם איפסום
          דולור סיט אמט נונסטי סוליקו קוואזי. קוואזי פרוייקט איי יו עיצמות קרטח טסניקט.
          בראיט לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סוליקו בלובסטיק
          עיצמות קרטח טסניקט סוספנדיס. לורם איפסום דולור סיט אמט קרטח. קונסקטורר
          אדיפיסינג בלובסטיק פרוייקט איי יו קוואזי. סוספנדיס סוליקו לורם איפסום.
          לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סוספנדיס לורם איפסום
          דולור סיט אמט נונסטי סוליקו קוואזי. קוואזי פרוייקט איי יו עיצמות קרטח טסניקט.
          בראיט לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סוליקו בלובסטיק
          עיצמות קרטח טסניקט סוספנדיס. לורם איפסום דולור סיט אמט קרטח. קונסקטורר
          אדיפיסינג בלובסטיק פרוייקט איי יו קוואזי. סוספנדיס סוליקו לורם איפסום.
          לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סוספנדיס לורם איפסום
          דולור סיט אמט נונסטי סוליקו קוואזי. קוואזי פרוייקט איי יו עיצמות קרטח טסניקט.
          בראיט לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סוליקו בלובסטיק
          עיצמות קרטח טסניקט סוספנדיס. לורם איפסום דולור סיט אמט קרטח. קונסקטורר
          אדיפיסינג בלובסטיק פרוייקט איי יו קוואזי. סוספנדיס סוליקו לורם איפסום.
        </p>
      </div>
    </div>
  );
};

export default DeliveryInfo;
